enum CleaningStatus {
  Clean,
  Neutral,
  Dirty,
  Cleaned,
  None,
}

export default CleaningStatus;
